import { addUtmSourceParamToUrl } from '@utils/url';
import { routing } from '@utils/routing';
import checkOutTheHelpCenter from '@modules/Dashboard/Home/modules/recommendations/assets/check-out-the-help-center.png';
import { useShopStage } from '@hooks';
import { useRecommendationsDismiss } from '@modules/Dashboard/Home/modules/recommendations/useRecommendationsDismiss';
export const useVisitHelpCenterRecommendation = () => {
    const { shopStage } = useShopStage();
    const { recommendationsDismiss, createOnDismiss } = useRecommendationsDismiss();
    return {
        visitHelpCenterRecommendation: {
            id: 'helpCenter',
            enabled: shopStage.stage2 && recommendationsDismiss.helpCenter.visible,
            suggestionProps: {
                type: 'props',
                props: {
                    title: 'Check out the Help Center',
                    description: 'Access helpful tips and resources.',
                    buttonLabel: 'Visit help center',
                    buttonHref: addUtmSourceParamToUrl(routing.external.helpCenter.self, 'onboarding'),
                    buttonTarget: '_blank',
                    imageUrl: checkOutTheHelpCenter,
                    analytics: 'visitHelpCenter',
                    onDismiss: createOnDismiss(recommendationsDismiss.helpCenter.dismiss),
                },
            },
        },
    };
};
